import { useNetworkCheck, usePublicConfig } from "../hooks/usePublicConfig";
import { chainNameForChainId } from "../lib/coinbase/network";

/**
 * Shown app-wide when this deployment's build-time chain ID disagrees with the server's
 * authoritative chain ID. This is a deployment misconfiguration, not a per-user wallet
 * issue — per Build.md the UI must refuse checkout in this state rather than guess.
 */
export function NetworkBanner() {
  const { isLoading, isError } = usePublicConfig();
  const network = useNetworkCheck();

  if (isLoading || isError || network.matches || network.serverChainId === null) {
    return null;
  }

  return (
    <div className="alert alert--danger" role="alert">
      <strong>Wrong network configuration.</strong>
      <p>
        This deployment is built for {chainNameForChainId(network.buildChainId)} (chain{" "}
        {network.buildChainId}), but the API reports {chainNameForChainId(network.serverChainId)}{" "}
        (chain {network.serverChainId}). Checkout is disabled until this is fixed — a purchase must
        never be sent to the wrong network.
      </p>
    </div>
  );
}
